// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "icon-2sOMC";
var _3 = "info-1fqxn";
export { _1 as "__esModule", _2 as "icon", _3 as "info" }
export default { "__esModule": _1, "icon": _2, "info": _3 }
